export default "__VITE_ASSET__DiR0ROIn__"